import { render, staticRenderFns } from "./CircularProgress.vue?vue&type=template&id=354e91a0&scoped=true"
import script from "./CircularProgress.vue?vue&type=script&lang=js"
export * from "./CircularProgress.vue?vue&type=script&lang=js"
import style0 from "./CircularProgress.vue?vue&type=style&index=0&id=354e91a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e91a0",
  null
  
)

export default component.exports